module.exports = __webpack_public_path__ + "static/media/prizm-golf.a56b7490.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/prizm-golf.mp4
// module id = 3537
// module chunks = 0